<template>
  <span>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex>
          <v-list two-line subheader>
            <v-subheader inset>بلاغاتي</v-subheader>

            <v-list-tile v-for="missing in userMissings" :key="missing.id" avatar>
              <v-list-tile-avatar>
                <img :src="missing.image" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{ missing.title }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ missing.description }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn @click="deleteUserMissing(missing.id)" icon ripple>
                  <v-icon color="red lighten-1">mdi-delete</v-icon>
                </v-btn>
                <Confirm @confirmed="confirmed" v-model="showConfirmation"></Confirm>
              </v-list-tile-action>
            </v-list-tile>

            <v-divider inset></v-divider>
          </v-list>
        </v-flex>
        <v-flex xs12>
          <div class="text-sm-center mt-5 mb-5">
            <v-pagination
              v-if="totalCount>10"
              :value="pageNumber"
              @input="updatePage"
              :length="pages"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </span>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Search from "../components/missings/Search";
import Confirm from "../components/Common/Confirm";
export default {
  data() {
    return {
      page: 1,
      showConfirmation: false,
      idToDelete: null
    };
  },
  components: {
    Search,
    Confirm
  },
  computed: {
    ...mapState({
      userMissings: state => state.MissingStore.userMissings,
      totalCount: state => state.MissingStore.totalCount,
      pageNumber: state => state.MissingStore.pageNumber,
      pageSize: state => state.MissingStore.pageSize
    }),
    pages() {
      if (this.totalCount === 0) return 0;
      let addedPage = 0;
      if (this.totalCount % this.pageSize > 0) addedPage = 1;
      return parseInt(this.totalCount / this.pageSize) + addedPage;
    }
  },
  methods: {
    ...mapActions(["getUserMissings", "deleteMissing"]),
    updatePage(pageNumber) {
      this.getUserMissings(pageNumber);
    },
    deleteUserMissing(id) {
      this.idToDelete = id;
      this.showConfirmation = true;
    },
    confirmed(value) {
      if (value && this.idToDelete) {
        this.deleteMissing(this.idToDelete);
        this.idToDelete = null;
      }
    }
  },
  created() {
    this.getUserMissings(this.pageNumber);
  }
};
</script>

<style scoped>
</style>